import React from 'react';
import { Play } from 'lucide-react';

const VideoSection = () => {
  return (
    <section className="section-padding-small bg-[var(--bg-primary)]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-4">Veja nossos projetos em ação</h2>
          <p className="body-regular text-[var(--text-secondary)]">
            Conheça a qualidade do nosso trabalho em detalhes
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Video 1 */}
          <div className="relative group hover-lift">
            <video
              controls
              className="w-full h-auto rounded-sm shadow-lg"
              poster="/assets/images/sacada-1.jpg"
            >
              <source src="/assets/videos/video-1.mp4" type="video/mp4" />
              Seu navegador não suporta a tag de vídeo.
            </video>
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors flex items-center justify-center pointer-events-none">
              <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                <Play className="w-8 h-8 text-[var(--text-primary)] ml-1" fill="currentColor" />
              </div>
            </div>
          </div>

          {/* Video 2 */}
          <div className="relative group hover-lift">
            <video
              controls
              className="w-full h-auto rounded-sm shadow-lg"
              poster="/assets/images/box-1.jpg"
            >
              <source src="/assets/videos/video-2.mp4" type="video/mp4" />
              Seu navegador não suporta a tag de vídeo.
            </video>
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors flex items-center justify-center pointer-events-none">
              <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                <Play className="w-8 h-8 text-[var(--text-primary)] ml-1" fill="currentColor" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
